import React, { FC }                     from 'react';
import { formatOption }                  from '../../../../util';
import { LangService }                   from '../../../../services';
import { INTAKE_QUESTION_CONTEXTS }      from '../../../../constants/ProductEnums';
import { INTAKE_QUESTION_CONTEXT_INFO }  from '../../../../constants/ProductEnums';
import { SelectField, SelectFieldProps } from '../../../components/forms';
import { PreSelectedSelectField }        from '../../../../types';

const Dropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let options = [
		formatOption( INTAKE_QUESTION_CONTEXTS.CORE, LangService.getTermFromDictionary( INTAKE_QUESTION_CONTEXT_INFO.CORE.LABEL ) ),
		formatOption( INTAKE_QUESTION_CONTEXTS.ADDITIVE, LangService.getTermFromDictionary( INTAKE_QUESTION_CONTEXT_INFO.ADDITIVE.LABEL ) ),
		formatOption( INTAKE_QUESTION_CONTEXTS.PROJECT, LangService.getTermFromDictionary( INTAKE_QUESTION_CONTEXT_INFO.PROJECT.LABEL ) ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

export { Dropdown as IntakeQuestionContextDropdown };
